import { useEffect, useState } from '../../common/common';
import axiosJWT from '../../secureAPI/axiosJWT.js';
import { showToast } from '../../Utils/toastUtils';
import { StartLoading, StopLoading } from '../../Utils/loadingUtils';
import { useErrorContext } from '../../context/ErrorContext';
import { validateEditwarehouse } from '../../validation/Authentication/Validation.js';
import useGetUserData from '../../secureAPI/GetUserData';
import Navigations from '../../common/useNavigation';

const MidWarehouse = (type) => {
    const { navigateDashboard } = Navigations();
    const { users,userPlan,Remainuser,subUser } = useGetUserData();
    const [isLoading, setisLoading] = useState(false);
    const { setValidationError, clearAllErrors } = useErrorContext();
    const [warehouse, setWarehouse] = useState([]);
    const [warehouseEditID, setEditwarehouseID] = useState();
    const [warehousedelteID, setDeletewarehouseID] = useState();


    const [showAddModal, setShowAddModal] = useState(false);
    const handleCloseAddModal = () => setShowAddModal(false);
    const handleShowAddModal = () => setShowAddModal(true);

    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const handleShowEditModal = (id) => {
        // alert(id)
        setEditwarehouseID(id);
        // Find the warehouse with the matching id
        const selectedwarehouse = warehouse.find(item => item.id === id);

        if (selectedwarehouse) {
            // Set the state with the selected warehouse's data
            setWarehouseDetails({
                title: selectedwarehouse.name,
                address: selectedwarehouse.warehouse_address,
                active: selectedwarehouse.status,
            });

            // Show the modal
            setShowEditModal(true);
        } else {
            alert('warehouse not found!');
        }
    };

    // Handle modal close
    const handleCloseEditModal = () => {
        setShowEditModal(false);
    };

    const handleCloseDeleteModal = () => setShowDeleteModal(false);
    const handleShowDeleteModal = (id) => {
        setDeletewarehouseID(id)
        setShowDeleteModal(true)
    };

    const [warehouseDetails, setWarehouseDetails] = useState({
        title: '',
        address: '',
        active: false,
    })

    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setWarehouseDetails((prevValues) => ({
            ...prevValues,
            [name]: value,
        }));
        // console.log({ values: warehouseDetails });
        if (Object.keys(validateAndSetErrors(warehouseDetails)).length === 0) clearAllErrors();
    };

    // Reusable function to handle validation and set errors
    const validateAndSetErrors = (values) => {
        const validationErrors = validateEditwarehouse(values);
        Object.keys(validationErrors).forEach(field => setValidationError(field, validationErrors[field]));
        return validationErrors;
    };

    useEffect(() => {
        const logUserData = () => {
            if (users?.length > 0) {
                const userTypes = users[0]['UserType'];
                const usertypeArray = typeof userTypes === 'string' ?
                    userTypes.split(',').map(str => parseInt(str.trim())).filter(num => !isNaN(num)) : [];

                const hasOne = usertypeArray.includes(1);
                const hasTwo = usertypeArray.includes(2);

                if (type === 'seller' && users[0]['IsPersonalDetils'] === 1 && (hasOne && hasTwo)) {
                    // Seller logic
                } else {
                    navigateDashboard('buyer');
                }
            }
        };

        if (Array.isArray(users) && users.length > 0) {
            logUserData();
        }
    }, [users, type, navigateDashboard]);

    useEffect(() => {
        getProductswarehouse();
    }, []);


    const getProductswarehouse = async () => {
        StartLoading(setisLoading);
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/Getwarehouse`, { app: 0 }, { withCredentials: true })
                .then((res) => {
                    StopLoading(setisLoading);
                    if (res.data.success === 1) {
                        setWarehouse(res.data.data);
                    }
                    else {
                        StopLoading(setisLoading)
                        showToast(res.data.message, 'error');
                    }
                })
                .catch((err) => {
                    StopLoading(setisLoading)
                    showToast('Something went wrong ! please try again ', 'error');
                });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to get suplliers, please try again later ", 'error');
        }
    }
    const handleActiveChange = (e) => {
        const { name, value, type, checked } = e.target;

        // Update state based on input type
        setWarehouseDetails((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    }

    const handlesubmit = async () => {
        const title = warehouseDetails.title;
        const address = warehouseDetails.address;
        const active = warehouseDetails.active;


        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/AddWarehouse`, { title, address, active }, { withCredentials: true })
                .then((response) => {
                    // console.log(response.data);
                    StopLoading(setisLoading);
                    if (response.data.success === 1) {
                        // console.log(response.data.warehouses);
                        setWarehouse(response.data.data.warehouses);
                        // getCategories(0);
                        StopLoading(setisLoading)
                        showToast(response.data.message, 'success');
                        // values.subCategoryName = "";
                        handleCloseAddModal();
                        setWarehouse([]);
                        getProductswarehouse();
                    }
                    else {
                        StopLoading(setisLoading)
                        showToast(response.data.message, 'error');
                    }
                })
                .catch((err) => {
                    const res_status = err.response.data.success;
                    const res_message = err.response.data.message;
                    if (res_status !== "" && res_message !== "") { }
                    else if (err.status === 401) {
                        // logout();
                    }
                    else {
                        showToast(err.data.message, 'error');
                    }
                });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to Add Warehouse, please try again later ", 'error');
        }
    };

    const handleSaveChanges = async () => {
       
        const title = warehouseDetails.title;
        const address = warehouseDetails.address;
        const active = warehouseDetails.active;

        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/EditWarehouse`, { warehouseEditID, title, address, active }, { withCredentials: true })
                .then((response) => {
                    // console.log(response.data);
                    StopLoading(setisLoading);
                    if (response.data.success === 1) {
                        // console.log(response.data);
                        setWarehouse(response.data.warehouses);
                        StopLoading(setisLoading)
                        showToast(response.data.message, 'success');
                        // values.subCategoryName = "";
                        handleCloseEditModal();
                    }
                    else {
                        StopLoading(setisLoading)
                        showToast(response.data.message, 'error');
                    }
                })
                .catch((err) => {
                    const res_status = err.response.data.success;
                    const res_message = err.response.data.message;
                    if (res_status !== "" && res_message !== "") { }
                    else if (err.status === 401) {
                        // logout();
                    }
                    else {
                        showToast(err.data.message, 'error');
                    }
                });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to Update Warehouse, please try again later ", 'error');
        }
    };

    const handleDelete = async () => {
        // Logic to delete the warehouse (e.g., update state or make an API call)
        // console.log("warehouse deleted");
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/DeleteWarehouse`, { warehousedelteID }, { withCredentials: true })
                .then((response) => {
                    // console.log(response.data);
                    StopLoading(setisLoading);
                    if (response.data.success === 1) {
                        // console.log(response.data);
                        setWarehouse(response.data.warehouses);
                        StopLoading(setisLoading)
                        setWarehouse([]);
                        getProductswarehouse();
                        showToast(response.data.message, 'success');
                        // values.subCategoryName = "";
                        handleCloseDeleteModal();
                    }
                    else {
                        StopLoading(setisLoading)
                        showToast(response.data.message, 'error');
                    }
                })
                .catch((err) => {
                    const res_status = err.response.data.success;
                    const res_message = err.response.data.message;
                    if (res_status !== "" && res_message !== "") { }
                    else if (err.status === 401) {
                        // logout();
                    }
                    else {
                        showToast(err.data.message, 'error');
                    }
                });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to Delete Warehouse, please try again later ", 'error');
        }

    };

    return {
        users,userPlan,Remainuser,subUser, isLoading, warehouse, setWarehouse, showEditModal, setShowEditModal, showDeleteModal, setShowDeleteModal,
        handleCloseEditModal, handleShowEditModal, handleCloseDeleteModal, handleShowDeleteModal, warehouseDetails, setWarehouseDetails, handleChange, handleDelete, handleSaveChanges, showAddModal, setShowAddModal, handleCloseAddModal, handleShowAddModal, handlesubmit, handleActiveChange
    }
}

export default MidWarehouse